// eslint-disable-next-line prettier/prettier
import translationEn from './locales/en/translation.json' with { type: 'json' };
// eslint-disable-next-line prettier/prettier
import translationFi from './locales/fi/translation.json' with { type: 'json' };
export const resources = {
    en: {
        translation: translationEn,
    },
    fi: {
        translation: translationFi,
    },
};
const localizationResources = {
    resources,
    supportedLanguages: Object.getOwnPropertyNames(resources),
};
export default localizationResources;
